import { useEffect } from "react";

export default function Home() {
  // useEffect(() => {

  //     var homeCont = document.getElementById("home-cont");
  //     var leslee = document.getElementById("leslee");
  //     console.log(homeCont);
  //     console.log(leslee.clientHeight);
  //     homeCont.style.height = leslee.clientHeight;
  // }, [useEffect])
  return (
    <>
      <div id="home">
        <div
          className="row welcome-leslee"
          style={{ backgroundColor: "#E4DEE6" }}
        >
          <div className="py-5 cooper purple col-xl-6 col-lg-6 col-md-6 mx-auto d-flex flex-column align-items-center text-center justify-content-center">
            <div className="">
              <h1
                className="cooper"
                style={{ fontSize: "2.5rem", fontWeight: "bold" }}
              >
                welcome!
              </h1>
            </div>

            <p
              className="welcome-text-g mb-1 cooperl"
              style={{ fontSize: "1.5rem" }}
            >
              hi, i'm leslee echivarre. nice to meet you!
            </p>

            <div className="px-md-1 cooperl">
              <p
                className=""
                style={{
                  color: "black",
                  fontSize: "1rem",
                  lineHeight: "1",
                  maxWidth: "600px",
                }}
              >
                I’m a communications and media professional based in the New
                York City metropolitan area, with a degree in Communication and
                Media Arts from Montclair State University. I’m focused on
                continuing to grow my career in production, media, and strategic
                communication, and I’m drawn to roles that allow me to build
                meaningful work while learning, collaborating, and making a
                positive impact.
              </p>
            </div>

            <div className="mt-4">
              <a
                href="https://www.linkedin.com/in/leslee-echivarre/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="leslee-button py-1"
                  style={{
                    paddingLeft: "80px",
                    paddingRight: "80px",
                    backgroundColor: "#6d5374",
                    borderRadius: "15px",
                    letterSpacing: "1px",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                >
                  CONTACT ME
                </button>
              </a>
            </div>
          </div>
          {/* <img id='' src='./img/leslee7.jpg' className="projects-img col-xl-6 col-lg-6 col-md-6 container-fill" alt="me" /> */}
          <div className="col-xl-6 col-lg-6 col-md-6 p-0 overflow-hidden">
            <img
              src="./img/leslee7.jpg"
              className="projects-img"
              alt="me"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // This prevents stretching
                display: "block",
                minHeight: "400px", // Ensures the image has presence on smaller/very wide screens
              }}
            />
          </div>
          {/* <div style={{backgroundColor: 'black', height: '10px', width: "100%"}}></div> */}
        </div>
        <div
          className="container mt-2 pt-5 pb-1 mb-1 cooperl"
          style={{ fontSize: "1.3rem", lineHeight: "1.1",  }}
        >
          <div className="row px-3">
            <h2
              className="cooper purple w-100"
              style={{ fontSize: "3rem", fontWeight: "bold" }}
            >
              about me
            </h2>
            <div className="col-sm-12 pl-0 mb-4">
              <div className="">
                I grew up alongside the evolution of social media, which shaped
                how I think about content, community, and culture. Today, I work
                in social media and content creation, helping brands show up in
                ways that feel thoughtful, human, and engaging.
              </div>
              <br />
              <div className="">
                I believe social media is most powerful when it builds trust and
                connection over time, not just numbers. I enjoy translating
                ideas into content that resonates, sparks conversation, and
                reflects a brand’s voice authentically.
              </div>
            </div>
          </div>
          <div className="row px-3">
            <h2 className="cooper purple w-100">experience includes:</h2>
            <div className="col-sm-12 pl-0 mb-4">
              <ul>
                <li>
                  4+ years of social media management and content creation
                </li>
                <li>3+ years of public relations and communications</li>
                <li>
                  3+ years of TV production, editorial writing, and digital
                  media
                </li>
                <li>6+ years of graphic design and creative content</li>
                <li>5+ years of customer service and audience-facing work</li>
              </ul>
            </div>
          </div>
          <div className="row px-3">
            <h2 className="cooper purple w-100">skills include:</h2>
            <div className="col-sm-12 pl-0 mb-4">
              <ul>
                <li>
                  Creative, Video & Audio Tools
                  <ul>
                    <li>
                      Adobe Premiere Pro, Adobe Photoshop, Canva, CapCut,
                      Procreate, Audacity, Riverside, Descript, StreamYard, Opus
                    </li>
                  </ul>
                </li>
                <li>Social, Marketing & Analytics Tools</li>
                <ul>
                  <li>
                    Sprout Social, Meta Business Suite, HubSpot, Brand24,
                    Megaphone
                  </li>
                </ul>
                <li>Automation, Forms & Organization</li>
                <ul>
                  <li>Airtable, Zapier, Typeform</li>
                </ul>
                <li>Social Platforms</li>
                <ul>
                  <li>
                    Instagram, TikTok, LinkedIn, Facebook, Bluesky, YouTube
                  </li>
                </ul>
                <li>Productivity & Collaboration</li>
                <ul>
                  <li>Google Workplace, Slack</li>
                </ul>
                <li>Languages</li>
                <ul>
                  <li>Bilingual in English and Tagalog</li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="mt-2 pb-1 mb-1 cooperl"
          style={{ fontSize: "1.3rem", lineHeight: "1.1" }}
        >
          <div
            className="row justify-content-center px-3 text-center"
            style={{ maxWidth: "1000px", margin: "0 auto" }}
          >
            <div
              className="cooper purple mb-2 w-100"
              style={{ fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: "bold" }}
            >
              social media & digital content
            </div>
            <div
              className="cooperl purple w-100 mx-auto px-md-5"
              style={{ fontSize: "1rem", maxWidth: "800px" }}
            >
              I manage and create content across multiple brands and
              organizational accounts.
            </div>

            <div className="row justify-content-center">
              {/* Item 1 */}
              <div className="col-12 col-sm-4 d-flex flex-column align-items-center mb-4">
                <a
                  href="https://www.linkedin.com/in/kimm4/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="./img/smdc/Kim.png"
                    className="img-fluid rounded-circle"
                    style={{
                      width: "80%",
                      maxWidth: "250px",
                      aspectRatio: "1 / 1",
                      objectFit: "cover",
                    }}
                    alt="Profile"
                  />
                </a>
                <div className="d-flex gap-3 justify-content-center">
                  <a
                    href="https://www.instagram.com/kimmalonescott/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/Kim_IG.png"
                      className="responsive-icon"
                      alt="kim ig"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/kimm4/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/Kim_LI.png"
                      className="responsive-icon"
                      alt="kim li"
                    />
                  </a>
                </div>
              </div>

              {/* Item 2 */}
              <div className="col-12 col-sm-4 d-flex flex-column align-items-center mb-4">
                <a
                  href="https://www.radicalcandor.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="./img/smdc/RC.png"
                    className="img-fluid rounded-circle"
                    style={{
                      width: "80%",
                      maxWidth: "250px",
                      aspectRatio: "1 / 1",
                      objectFit: "cover",
                    }}
                    alt="Logo 1"
                  />
                </a>
                <div className="d-flex gap-3 justify-content-center">
                  <a
                    href="https://www.instagram.com/radicalcandorofficial/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/RC_IG.png"
                      className="responsive-icon"
                      alt="rc ig"
                    />
                  </a>
                  <a
                    href="https://www.tiktok.com/@radicalcandorofficial"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/RC_Tiktok.png"
                      className="responsive-icon"
                      alt="rc li"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/radical-candor/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/RC_LI.png"
                      className="responsive-icon"
                      alt="rc li"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/@RadicalCandor"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/RC_YT.png"
                      className="responsive-icon"
                      alt="rc yt"
                    />
                  </a>
                </div>
              </div>

              {/* Item 3 */}
              <div className="col-12 col-sm-4 d-flex flex-column align-items-center mb-4">
                <a
                  href="https://www.musiccouncil.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="./img/smdc/NMC.png"
                    className="img-fluid rounded-circle"
                    style={{
                      width: "80%",
                      maxWidth: "250px",
                      aspectRatio: "1 / 1",
                      objectFit: "cover",
                    }}
                    alt="Logo 2"
                  />
                </a>
                <div className="d-flex gap-3 justify-content-center">
                  <a
                    href="https://www.instagram.com/nmcouncil"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/NMC_IG.png"
                      className="responsive-icon"
                      alt="nmc ig"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/national-music-council/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/NMC_LI.png"
                      className="responsive-icon"
                      alt="nmc li"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/@nmcouncil"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/smdc/NMC_YT.png"
                      className="responsive-icon"
                      alt="nmc yt"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            className="pb-1 cooperl w-100"
            style={{
              fontSize: "1.3rem",
              lineHeight: "1.1",
              backgroundColor: "white",
            }}
          >
              <div className="row justify-content-center px-3 text-center py-3">
            <div className="container">
              <div
                className="cooper purple my-1"
                style={{
                  fontSize: "clamp(2rem, 5vw, 3rem)",
                  fontWeight: "bold",
                }}
              >
                explore my work
              </div>
              A selection of projects spanning social growth, content strategy,
              and automation systems.
            </div>
            </div>
          </div>
          <div
            className="pb-1 mb-1 white cooperl"
            style={{
              fontSize: "1.3rem",
              lineHeight: "1.1",
              backgroundColor: "#6d5374",
            }}
          >
            <div className="">
              <div className="row justify-content-center pt-3 px-3 text-center py-3 mb-3">
                <div
                  id="carouselExample2"
                  className="carousel carousel-fade align-items-center"
                  data-bs-ride="carousel"
                  style={{ minHeight: "100px" }}
                >
                  <div style={{maxWidth: "1000px", margin: "0 auto"}} className="carousel-inner justify-content-start">
                    <div className="carousel-item active text-start">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooper my-5"
                          style={{
                            fontSize: "clamp(2rem, 5vw, 3rem)",
                            fontWeight: "bold",
                          }}
                        >
                          Radical Candor: Multi-Platform Social Growth
                        </div>
                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.3rem" }}
                        >
                          Led organic social strategy across Instagram,
                          LinkedIn, TikTok, and YouTube, driving significant
                          growth and engagement through short-form video and
                          platform-native storytelling.
                        </div>
                        <br />

                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.3rem" }}
                        >
                          Highlights:
                          <ul>
                            <li>+17.5K net followers</li>
                            <li>6.5M+ impressions</li>
                            <li>620K+ engagements</li>
                            <li>3,000%+ video growth</li>
                          </ul>
                        </div>
                        <br />

                        <div className=" justify-content-center d-flex mx-auto">
                          <a
                            href="https://lesleeechivarre.s3.us-east-1.amazonaws.com/Radical+Candor+-+Social+Media+Growth+%26+Impact+(2024%E2%80%932025)-2.pdf"
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none"
                          >
                            <button
                              className="leslee-button purple py-1 mt-3"
                              style={{
                                backgroundColor: "#E4DEE6",
                              }}
                            >
                              VIEW GROWTH AND IMPACT
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item text-start">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooper my-5"
                          style={{
                            fontSize: "clamp(2rem, 5vw, 3rem)",
                            fontWeight: "bold",
                          }}
                        >
                          Year-End Reflection: Interactive & Automated
                          Experience
                        </div>
                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.3rem" }}
                        >
                          Expanded a downloadable leadership reflection
                          worksheet into an interactive Typeform experience with
                          automated email delivery, increasing accessibility and
                          long-term engagement.
                        </div>
                        <br />

                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.3rem" }}
                        >
                          Highlights:
                          <ul>
                            <li>Built Typeform + Zapier workflow</li>
                            <li>Automated personalized PDF delivery</li>
                            <li>35% completion rate</li>
                            <li>11+ minute average engagement time</li>
                          </ul>
                        </div>
                        <br />

                        <div className=" justify-content-center d-flex mx-auto">
                          <a
                            href="https://lesleeechivarre.s3.us-east-1.amazonaws.com/Year-End+Reflection+-+Portfolio.pdf"
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none"
                          >
                            <button
                              className="leslee-button purple py-1 mt-3"
                              style={{
                                backgroundColor: "#E4DEE6",
                              }}
                            >
                              VIEW CASE STUDY
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExample2"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExample2"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="pb-1 mb-1 cooperl"
            style={{
              fontSize: "1.3rem",
              lineHeight: "1.1",
              backgroundColor: "#E4DEE6",
            }}
          >
            <div className="">
              <div className="row justify-content-center pt-3 px-3 text-center py-3 mb-3">
                <div
                  className="cooper purple my-5"
                  style={{
                    fontSize: "clamp(2rem, 5vw, 3rem)",
                    fontWeight: "bold",
                  }}
                >
                  words & testimonials
                </div>

                <div
                  id="carouselExample"
                  className="carousel carousel-fade align-items-center"
                  data-bs-ride="carousel"
                  style={{ minHeight: "100px" }}
                >
                  <div style={{maxWidth: "1000px", margin: "0 auto"}} className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.5rem" }}
                        >
                          “I had the great pleasure of working with Leslee on Radical Candor's social media presence for two years, and I came to admire her enormously over that time. Leslee works hard and has a real can-do approach. We changed our strategy several times, and she modeled listen-challenge-commit. She was not afraid to ask the important questions--sometimes causing us to change our plans--and she understood when we needed to quit debating and start implementing changes. She is super-creative and came up with great ways to use AI to create the images for many of our posts. while agreeing with our stance that humans should write the words.“
                        </div>
                        <div className="mt-2 text-cent w-100">
                          <div className="text-cent text-responsive-smallest">
                            <strong>Kim Scott</strong>
                            <br></br>
                            <p className="desc">
                              Author,
                              Radical Candor
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.5rem" }}
                        >
                          “Leslee is exceptional at turning brand strategy into
                          social media growth that actually lasts. I worked with
                          Leslee as her direct supervisor at Radical Candor,
                          where she played a key role in growing our social
                          media presence and overall brand awareness. Her work
                          helped drive major organic gains across platforms,
                          including a 3,000%+ increase in video views and a 223%
                          rise in engagement in her first year, alongside strong
                          growth on LinkedIn, Instagram, and TikTok. Leslee is
                          strategic, data-driven, and exceptional at turning
                          brand voice into content that resonates and builds
                          long-term brand equity.“
                        </div>
                        <div className="mt-2 text-cent w-100">
                          <div className="text-cent text-responsive-smallest">
                            <strong>Brandi Neal</strong>
                            <br></br>
                            <p className="desc">
                              Former Director of Content Creation & Marketing,
                              Radical Candor
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooperl pb-4"
                          style={{
                            fontSize: "1.5rem",
                            maxWidth: "1000px",
                            justifyContent: "center",
                            margin: "0 auto",
                          }}
                        >
                          “I had the chance to manage Leslee for a couple of months, and she made such a positive impression in that short time. She brings a genuinely warm, upbeat energy to everything she does and is always ready to jump in wherever she’s needed. She’s curious, open to feedback, and truly excited to learn, which makes her such a great teammate to collaborate with. I especially appreciated the fresh ideas she brought to our social content and her willingness to experiment and try new things. She’s a thoughtful, collaborative teammate and a joy to work with.”
                        </div>
                        <div className="mt-2 text-cent w-100">
                          <div className="text-cent text-responsive-smallest justify-content-center">
                            <strong>Sipra Roy Halteman</strong>
                            <br></br>
                            <div
                              style={{ maxWidth: "500px" }}
                              className="desc text-cent mx-auto"
                            >
                              Director of Marketing, Radical Candor
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooperl pb-4"
                          style={{
                            fontSize: "1.5rem",
                            maxWidth: "1000px",
                            justifyContent: "center",
                            margin: "0 auto",
                          }}
                        >
                          “Leslee’s excellent writing, organizational, and
                          content creation skills were critical to increasing
                          awareness and engagement across social media and web
                          platforms.”
                        </div>
                        <div className="mt-2 text-cent w-100">
                          <div className="text-cent text-responsive-smallest justify-content-center">
                            <strong>Keith Green, APR</strong>
                            <br></br>
                            <div
                              style={{ maxWidth: "500px" }}
                              className="desc text-cent mx-auto"
                            >
                              Assistant Professor of Public Relations and
                              Strategic Communications/Coordinator of Strategic
                              Communications
                            </div>
                          </div>

                          <div className=" justify-content-center d-flex mx-auto">
                            <a
                              href="https://lesleeechivarre.s3.amazonaws.com/Leslee_Echivarre_Letter_of_Recommendation.pdf"
                              target="_blank"
                              rel="noreferrer"
                              className="text-decoration-none"
                            >
                              <button
                                className="leslee-button py-1 mt-3"
                                style={{
                                  backgroundColor: "#6d5374",
                                }}
                              >
                                READ FULL LETTER HERE
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="col-sm-12 pt-2 pl-0 mb-4">
                        <div
                          className="cooperl pb-4"
                          style={{ fontSize: "1.5rem" }}
                        >
                          “Leslee possesses a very unique combination of
                          creativity, determination, and kindness“
                        </div>
                        <div className="mt-2 text-cent w-100">
                          <div className="text-cent text-responsive-smallest">
                            <strong>Beverly Zapatka Weihz</strong>
                            <br></br>
                            <p className="desc">Stateliner Media</p>
                          </div>
                          <a
                            href="https://lesleeechivarre.s3.amazonaws.com/Leslee_Echivarre_-_Reference_Letter.pdf"
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none"
                          >
                            <button
                              className="leslee-button py-1 mt-3"
                              style={{
                                backgroundColor: "#6d5374",
                              }}
                            >
                              READ FULL LETTER HERE
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExample"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExample"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="fade mt-5 mb-5 pt-5 pb-5" style={{backgroundColor: "white"}}>
            <div className="row justify-content-center">
                <a style={{color: "black"}} target="_blank" href="https://www.linkedin.com/in/leslee-echivarre"><button style={{backgroundColor: '#c9b29e', color: "black"}} type="button" className="times btn btn-secondary btn-lg text-responsive">Contact Me Here</button></a>
            </div>
            </div>
            */}
      </div>
    </>
  );
}
